export const environment = {
    production: false,
    // api_url: 'http://127.0.0.1:8000/',
    api_url: 'https://api.staging.pam-llm.nextleap.ai/',
	nextLeapURL:'https://staging.nextleap.ai/'
};

